module.exports = __webpack_public_path__ + "static/media/item_28_2.87435c78.png";